export default function useDataConfiguration(props) {
  return {
    variables: {
      patient_id: props.patientId,
    },
    pause: !props.patientId,
  }
}
